import {CreateResumeRequest} from "typings/resume";
import {endpoints} from "services/_endpoints";
import {postUrl} from "utils/http";

export const createResume = (input: CreateResumeRequest): Promise<any> =>  {
  return postUrl(endpoints.generateTex, input);
}